module.exports = __webpack_public_path__ + "static/media/Home Video.1f9b61f4.mp4";